export const SessionStorageKeys = {
  prefersCamera: 'prefers_camera',
  invalidRequestData: 'invalid_request_data',
  code: 'code',
}
